module.exports = __webpack_public_path__ + "static/media/ic_pa_b1_fisdom.06728b8c.svg";